import React from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import get from 'lodash/get';
import useCurrentPage from '../../../../hooks/useCurrentPage';
import { pure } from '../../../../../src/web/utils/react';
import styles from './AvailableUnitsCount.scss';

const propTypes = {
  availableUnitsCount: PropTypes.number.isRequired,
  facility: PropTypes.shape({
    settings: PropTypes.shape({
      showAvailableUnitCountThreshold: PropTypes.number,
      showAvailableUnitCount: PropTypes.bool,
    }),
  }).isRequired,
};

const getDisplayText = count => (
  `${pluralize('unit', count, true)} left!`
);
const AvailableUnitsCount = ({ facility, availableUnitsCount }) => {
  const { secondaryColorClass } = useCurrentPage();
  if (availableUnitsCount > 0) {
    const limit = get(facility, 'settings.showAvailableUnitCountThreshold');
    const display = get(facility, 'settings.showAvailableUnitCount');
    if (!display) {
      return null;
    }
    if (limit && limit < availableUnitsCount) {
      return null;
    }
    return (
      <div className={`${styles.availableUnits} ${secondaryColorClass}`}>
        {getDisplayText(availableUnitsCount)}
      </div>
    );
  }
  return null;
};

AvailableUnitsCount.propTypes = propTypes;

export default pure()(AvailableUnitsCount);
